import React from 'react';
import PropTypes from 'prop-types';
import StartupsSelect from 'components/StartupsSelect';
// import Notifications from 'components/Notifications';
import { SideBar } from 'xland-ui';
import { useSelector } from 'react-redux';
import { getFullName } from 'utils/functions';
import { ROUTE_PATH, ROUTE_POSITION_PATH } from 'routes';
import { createBillingSession } from 'modules/sprite/repository';
import {
  ArrowRightLeft, Banknote, DoorClosed, Info, User,
} from 'lucide-react';
import ShareholdersSelect from 'components/ShareholdersSelect';
import CurrenciesSelect from 'components/CurrencySelect';
import OrganizationSelect from 'components/StartupsSelect/OrganizationSelect';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNavRows } from '../hooks/useNavRows';
import './styles.scss';

function LeftMenu({ literals, platform, route }) {
  const location = useLocation();
  const navRows = useNavRows();
  const navigate = useNavigate();

  const startup = useSelector(state => state.global.startup);
  const user = useSelector(state => state.session.user);

  const preferences = JSON.parse(localStorage.getItem('preferences')) || {};

  const profile = {
    name: getFullName(user),
    routes: [
      { name: literals.account, icon: User, to: ROUTE_PATH.EDIT_ACCOUNT },
      {
        name: literals.help,
        icon: Info,
        to: ROUTE_PATH.HELP,
        hidden: true,
      },
      {
        name: `${literals.switchTo || 'Switch to'} ${preferences.mode === 'investor' ? literals.founder || 'Founder' : literals.investor || 'Investor'}`,
        icon: ArrowRightLeft,
        hidden: user.role[0] !== 'user',
        onClick: () => {
          preferences.mode = preferences.mode === 'investor' ? 'founder' : 'investor';
          localStorage.setItem('preferences', JSON.stringify(preferences));
          navigate(ROUTE_PATH.BASEROUTE);
        },
      },
      {
        name: literals.billing || 'Billing',
        icon: Banknote,
        hidden: user.role[0] !== 'user' || preferences.mode !== 'investor' || !user.stripe,
        onClick: () => {
          createBillingSession({
            returnUrl: window.location.href,
          }).then(res => {
            window.open(res.url, '_self');
          });
        },
      },
      { name: literals.logout, icon: DoorClosed, to: ROUTE_PATH.LOGOUT },
    ],
  };

  return (
    <SideBar
      literals={literals}
      profile={profile}
      navRows={navRows?.upper || []}
      bottomRows={navRows?.bottom || []}
      allowShowAside={navRows?.upper?.length > 0}
      actualPath={route.path}
    >
      {startup && (
        <li className='mb-2'>
          <StartupsSelect
            startup={startup}
            platform={platform}
            offset={{ left: 26 }}
          />
        </li>
      )}

      {location.pathname.startsWith('/investments') && (
        <li className='mb-2'>
          <OrganizationSelect
            platform={platform}
            offset={{ left: 26 }}
          />
        </li>
      )}

      {route.path.startsWith(ROUTE_POSITION_PATH.BASE) && (
        <>
          <li className='mb-2'>
            <div className='nav-item'>
              <ShareholdersSelect />
            </div>
          </li>
          <li className='mb-2'>
            <div className='nav-item'>
              <CurrenciesSelect mode='position' />
            </div>
          </li>
        </>
      )}
    </SideBar>
  );
}

LeftMenu.propTypes = {
  literals: PropTypes.object.isRequired,
  route: PropTypes.object.isRequired,
  platform: PropTypes.object.isRequired,
};

export default LeftMenu;
